module.exports = __webpack_public_path__ + "img/limited_functionality.934dba3a.svg";